function getVariation(placement) {
  return placement.split('-')[1];
}

export { getVariation as default };
//# sourceMappingURL=getVariation.js.map
